module.exports = __webpack_public_path__ + "static/media/undercounter.faa72455.png";